import { call, put } from 'redux-saga/effects';

import generateQuery from 'utils/generateQuery';

import {
  axiosAuthInstance,
  API_END_POINTS,
} from 'api';
import { MESSAGES } from 'appconstants';

import {
  WALLET_TRANSACTION,
  NOTIFICATION,
} from '../actionTypes';

const fetchWalletTransaction = async (payload) => {
  let parms = '';
  const queryParam = payload.searchParam;
  if (queryParam && queryParam !== 'ALL') {
    parms = `type.EQ=${payload.searchParam}`;
  } else if (queryParam && queryParam === 'ALL') {
    parms = '';
  }
  const query = generateQuery(payload.currentPage);
  const sorting = payload.sortParams ? payload.sortParams : '&sortBy=createdAt&direction=DESC';
  if (parms && !payload.filterParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.WALLET_TRANSACTION}${query}&${parms}${sorting}`);
  }
  if (payload.filterParams && !parms && !payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.WALLET_TRANSACTION}${query}&${payload.filterParams}`);
  }
  if (payload.filterParams && parms && payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.WALLET_TRANSACTION}${query}&${parms}&${payload.filterParams}${sorting}`);
  }
  if (payload.filterParams && !parms && payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.WALLET_TRANSACTION}${query}&${payload.filterParams}${sorting}`);
  }
  return axiosAuthInstance.get(`${API_END_POINTS.WALLET_TRANSACTION}${query}${sorting}`);
};

export function* getWalletTransaction(action) {
  try {
    const { data: { entity } } = yield call(fetchWalletTransaction, action.payload);
    yield put({ type: WALLET_TRANSACTION.SUCCESS, payload: entity });
  } catch (e) {
    yield put({ type: WALLET_TRANSACTION.FAILED, payload: e.response.data });
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  }
}
